
import Vue from "vue";
import Component from "vue-class-component";
import AppNavbarSecondary from "@/components/layout/AppNavbarSecondary.vue";
import HeaderPartnership from "@/components/partnership/HeaderPartnership.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import News from "@/components/content-management/news/News.vue";
import { State } from "vuex-class";

@Component({
  components: {
    AppNavbarSecondary,
    HeaderPartnership,
    News,
    AppFooter,
  },
})
export default class Partnership extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;

  private get isHighSchool() {
    return false;
  }
  private get templateNumber() {
    return Number(this.$route.query.template) || 1;
  }
}
